var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-date-picker-dropdown.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element";
import { css } from "@adornis/chemistry/directives/css";
import "@adornis/chemistry/elements/components/x-button";
import { inputToken } from "@adornis/chemistry/elements/theming/input-token";
import { elevation } from "@adornis/chemistry/elements/token-helpers";
import { xComponents } from "@adornis/chemistry/elements/x-components";
import { FormField } from "@adornis/forms/form-field";
import "@adornis/popover/a-drop-wrapper";
import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { ref } from "lit/directives/ref.js";
import { DateTime } from "luxon";
import { fromEvent } from "rxjs";
import { delay, distinctUntilChanged, map, takeUntil } from "rxjs/operators";
import "tippy.js";
import { ElementsDialog } from "@adornis/dialog/x-dialog";
import "./x-basic-date-picker";
import "./x-time-picker";
import { isMobile } from "@adornis/base/client/frontend-helpers/window-size";
import { DesignSystem } from "@adornis/chemistry/elements/theming/design";
import { intrinsicHeight } from "@adornis/chemistry/controllers/loader";
import { ObservableController } from "@adornis/chemistry/controllers/observable-controller";
var ElementsDatePickerDropdown = class extends FormField {
  constructor() {
    super();
    this.styles = () => ({
      ":host([error]) #trigger": { borderColor: this.colors.tone.error + " !important" }
    });
    this.activated = false;
    this["show-time"] = false;
    this.placeholder = "";
    this["placeholder-mode"] = "floating";
    this["click-to-save"] = false;
    this["placeholder-save"] = "Speichern";
    this["placeholder-cancel"] = "Schlie\xDFen";
    this._renderDialog = new ObservableController(
      this,
      intrinsicHeight.pipe(
        map((height) => this._shouldOpenDialog()),
        distinctUntilChanged()
      )
    );
    this.isDateBlocked = (date) => false;
    this.highlightedDate = (date) => false;
    this._dialogOpen = false;
    if (_DatePickerHeight === -1)
      getDatePickerHeight();
  }
  get inputToken() {
    return inputToken(this);
  }
  connectedCallback() {
    super.connectedCallback();
    this.setAttribute("tabindex", "0");
    fromEvent(this, "focus", { passive: true }).pipe(delay(100), takeUntil(this.disconnected)).subscribe(async () => {
      if (!this.disabled) {
        if (!this.activated) {
          this.activated = true;
          await this.updateComplete;
        }
        this._renderDialog.value ? this._openDialog() : this._adropdown?.open();
      }
    });
  }
  render() {
    const showLabel = !!this.value.value || this.error;
    const trigger = xComponents(html`
      <x-flex
        slot="trigger"
        @click=${async () => {
      if (!this.activated) {
        this.activated = true;
        await this.updateComplete;
      }
      if (!this.disabled)
        this._adropdown?.toggle();
    }}
      >
        ${(this.placeholder?.trim() || this.error) && this["placeholder-mode"] === "floating" ? html`
              <x-text
                ${css({
      marginLeft: this.spacing.md,
      marginBottom: showLabel ? this.spacing.xs : "0",
      opacity: showLabel ? "1" : "0",
      transform: showLabel ? "translateY(0)" : "translateY(20px)",
      transition: "opacity .12s ease, transform .12s ease, max-height .12s ease, margin .12s ease",
      maxHeight: showLabel ? "30px" : "0px",
      color: this.error ? this.colors.tone.error : ""
    })}
                tone="subtle"
              >
                ${this.error || this.placeholder}
              </x-text>
            ` : nothing}
        <x-flex
          horizontal
          crossaxis-center
          id="trigger"
          space="sm"
          ${css({
      ...this.inputToken,
      height: `calc(${this.baseFontSize}px + ${this.inputToken.paddingTop} + ${this.inputToken.paddingBottom} + 2px)`,
      ...this.error ? { borderColor: this.colors.tone.error } : {}
    })}
        >
          ${this["placeholder-mode"] === "prefix" && this.placeholder?.trim() && this.value.getValue() ? html` <x-text flex-none tone="subtle"> ${this.placeholder} </x-text> ` : nothing}
          <x-text tone="${!this.value.getValue() ? "subtle" : ""}">
            ${this.value.getValue() ? this["show-time"] ? this.value.getValue()?.toLocaleString(DateTime.DATETIME_SHORT) : this.value.getValue()?.toLocaleString(DateTime.DATE_SHORT) : this.placeholder || "Datum ausw\xE4hlen"}
          </x-text>
        </x-flex>
      </x-flex>
    `);
    if (!this.activated)
      return html` <x-flex> ${trigger} </x-flex> `;
    return this._renderDialog.value ? this._dialog(trigger) : this._dropdown(trigger);
  }
  _dropdown(trigger) {
    return xComponents(html`
      <a-dropdown
        ${css({ cursor: !this.disabled ? "pointer" : "initial" })}
        .options=${{
      hideOnClick: this["click-to-save"] ? true : "toggle",
      onClickOutside(instance, event) {
      }
    }}
        @value-picked=${(e) => this._emitValue(e)}
        ${ref((dropdown) => this._adropdown = dropdown)}
      >
        ${trigger}
        <x-date-picker-dropdown-content
          slot="dropdown-content"
          .date=${this.value.getValue() || DateTime.now()}
          ?show-time=${this["show-time"]}
          ?click-to-save=${this["click-to-save"]}
          .isDateBlocked=${this.isDateBlocked}
          .highlightedDate=${this.highlightedDate}
          placeholder-save=${this["placeholder-save"]}
          placeholder-cancel=${this["placeholder-cancel"]}
        ></x-date-picker-dropdown-content>
      </a-dropdown>
    `);
  }
  _emitValue(e) {
    this.value.next(e.detail.value);
    this.dispatchEvent(new CustomEvent("date-picked", { detail: { value: e.detail.value } }));
    this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: this.value.value } }));
  }
  _dialog(trigger) {
    return html` <x-flex @click=${() => this._openDialog()} ${css({ cursor: "pointer" })}> ${trigger} </x-flex> `;
  }
  _openDialog() {
    if (this._dialogOpen)
      return;
    this._dialogOpen = true;
    ElementsDialog.showPopup({
      content: (resolve) => html`
        <x-date-picker-dropdown-content
          .useTrigger=${false}
          .date=${this.value.getValue() || DateTime.now()}
          ?show-time=${this["show-time"]}
          ?click-to-save=${this["click-to-save"]}
          .isDateBlocked=${this.isDateBlocked}
          .highlightedDate=${this.highlightedDate}
          placeholder-save=${this["placeholder-save"]}
          placeholder-cancel=${this["placeholder-cancel"]}
          @value-picked=${(e) => {
        this._emitValue(e);
        resolve();
      }}
          @close=${() => resolve()}
        ></x-date-picker-dropdown-content>
      `
    }).finally(() => this._dialogOpen = false);
  }
  _shouldOpenDialog() {
    return isMobile() || _DatePickerHeight > intrinsicHeight.getValue() * 0.45;
  }
};
__decorateClass([
  property({ type: Boolean })
], ElementsDatePickerDropdown.prototype, "activated", 2);
__decorateClass([
  property({ type: Boolean })
], ElementsDatePickerDropdown.prototype, "show-time", 2);
__decorateClass([
  property()
], ElementsDatePickerDropdown.prototype, "placeholder", 2);
__decorateClass([
  property()
], ElementsDatePickerDropdown.prototype, "placeholder-mode", 2);
__decorateClass([
  property({ type: Boolean })
], ElementsDatePickerDropdown.prototype, "click-to-save", 2);
__decorateClass([
  property()
], ElementsDatePickerDropdown.prototype, "placeholder-save", 2);
__decorateClass([
  property()
], ElementsDatePickerDropdown.prototype, "placeholder-cancel", 2);
__decorateClass([
  state()
], ElementsDatePickerDropdown.prototype, "_renderDialog", 2);
ElementsDatePickerDropdown = __decorateClass([
  customElement("x-date-picker-dropdown")
], ElementsDatePickerDropdown);
var ElementsDatePickerDropdownContent = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.date = DateTime.now();
    this["show-time"] = false;
    this["click-to-save"] = false;
    this.useTrigger = true;
    this["placeholder-save"] = "Speichern";
    this["placeholder-cancel"] = "Schlie\xDFen";
    this.isDateBlocked = (date) => false;
    this.highlightedDate = (date) => false;
  }
  receiveTrigger(trigger) {
    this._trigger = trigger;
  }
  render() {
    return xComponents(html`
      <x-flex
        padding="sm"
        space="md"
        ${css({ background: this.colors.white, boxShadow: elevation[2], borderRadius: this.sizes.borderRadius })}
      >
        <x-basic-date-picker
          .date=${this.date}
          @value-picked=${async (e) => {
      this.date = e.detail.value;
      if (this["click-to-save"]) {
        requestAnimationFrame(() => this._emitValue(e.detail.value));
      }
    }}
          .isDateBlocked=${this.isDateBlocked}
          .highlightedDate=${this.highlightedDate}
        ></x-basic-date-picker>
        ${this["show-time"] ? html`
              <x-time-picker
                @value-changed=${(e) => {
      if (this.date.hour !== e.detail.value.hour || this.date.minute !== e.detail.value.minute)
        this.date = this.date.set({ hour: e.detail.value.hour, minute: e.detail.value.minute });
    }}
                .value=${this.date}
              ></x-time-picker>
            ` : nothing}
        ${!this["click-to-save"] ? html`
              <x-flex horizontal space-between space="md">
                <x-button
                  mode="outline"
                  @click=${() => {
      if (this.useTrigger) {
        this._trigger?.toggle();
      } else {
        this.dispatchEvent(new CustomEvent("close"));
      }
    }}
                >
                  ${this["placeholder-cancel"]}
                </x-button>
                <x-button @click=${() => this._emitValue(this.date)}> ${this["placeholder-save"]} </x-button>
              </x-flex>
            ` : nothing}
      </x-flex>
    `);
  }
  _emitValue(date) {
    if (this.useTrigger) {
      this._trigger?.dispatchEvent(new CustomEvent("value-picked", { detail: { value: date } }));
      this._trigger?.toggle();
      return;
    }
    this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: date } }));
  }
};
__decorateClass([
  state()
], ElementsDatePickerDropdownContent.prototype, "date", 2);
__decorateClass([
  property({ type: Boolean })
], ElementsDatePickerDropdownContent.prototype, "show-time", 2);
__decorateClass([
  property({ type: Boolean })
], ElementsDatePickerDropdownContent.prototype, "click-to-save", 2);
__decorateClass([
  state()
], ElementsDatePickerDropdownContent.prototype, "useTrigger", 2);
__decorateClass([
  property()
], ElementsDatePickerDropdownContent.prototype, "placeholder-save", 2);
__decorateClass([
  property()
], ElementsDatePickerDropdownContent.prototype, "placeholder-cancel", 2);
ElementsDatePickerDropdownContent = __decorateClass([
  customElement("x-date-picker-dropdown-content")
], ElementsDatePickerDropdownContent);
var _DatePickerHeight = -1;
var getDatePickerHeight = async () => {
  const dropdown = document.createElement(`${DesignSystem.prefix}-date-picker-dropdown-content`);
  dropdown.style.setProperty("position", "fixed");
  dropdown.style.setProperty("top", "-1000px");
  dropdown.style.setProperty("left", "-1000px");
  dropdown.style.setProperty("opacity", "0");
  dropdown.style.setProperty("pointer-events", "none");
  document.body.appendChild(dropdown);
  await new Promise((r) => requestAnimationFrame(() => r()));
  _DatePickerHeight = dropdown.offsetHeight;
  document.body.removeChild(dropdown);
};
export {
  ElementsDatePickerDropdown,
  ElementsDatePickerDropdownContent
};
